import { portWithWrites, portWritesBrand, type PortEnv, type PortWithWrites, type PortWriteIntent } from '../../port-contract';
import { phpCopy } from '../../php-compat';

/** Dependency ports decide their own writes; the parent preserves their order
 * and exposes native values to the unchanged PHP decision/calling convention. */
export function withDependencyWrites<T, Deps extends object>(env: PortEnv<Deps>, decide: (env: PortEnv<Deps>) => T): PortWithWrites<T> {
    const writes: PortWriteIntent[] = [];
    const deps = new Proxy(env.deps, {
        get(target, name) {
            const member = Reflect.get(target, name);
            if (typeof member !== 'function') return member;
            return (...args: unknown[]) => {
                const result = member.apply(target, args);
                if (result?.[portWritesBrand] !== true) return result;
                for (const intent of result.writes as PortWriteIntent[]) writes.push({
                    sql: intent.sql,
                    params: phpCopy(intent.params),
                    ...(intent.param_types === undefined ? {} : { param_types: phpCopy(intent.param_types) }),
                });
                return result.value;
            };
        },
    });
    return portWithWrites(decide({ ...env, deps }), writes);
}
